// @flow

import styled from 'styled-components';
import React, { type Node } from 'react';

type Props = {|
  label: string,
  text: string,
|};

export function Tooltip({ label, text }: Props): Node {
  return (
    <TooltipStyled>
      <TooltipBadge>{label}</TooltipBadge>
      <TooltipContainer>
        <TooltipBody>
          <p>{text}</p>
        </TooltipBody>
        <TooltipArrow />
      </TooltipContainer>
    </TooltipStyled>
  );
}

const TooltipBadge = styled.span`
  background-color: ${props => props.theme.colors.gray(80)};
  border-radius: 1em;
  color: white;
  font-size: .9em;
  padding: 0 .5em;
  `;

const TooltipArrow = styled.i`
  height: 12px;
  left: 22px;
  margin-left: -12px;
  overflow: hidden;
  position: absolute;
  top: 100%;
  width: 24px;

  &:after {
    background-color: ${props => props.theme.colors.primary(50)};
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.18);
    content: "";
    height: 15px;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 15px;
  }
  `;

const TooltipBody = styled.div`
  font-size: 12px;
  font-weight: normal;
`;

const TooltipContainer = styled.div`
  background-color: ${props => props.theme.colors.primary(50)};
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18);
  box-sizing: border-box;
  color: white;
  left: 46px;
  min-width: 200px;
  opacity: 0;
  padding: 6px 10px;
  position: absolute;
  top: -1em;
  z-index: 99999999;
  `;

const TooltipStyled = styled.span`
  cursor: pointer;
  display: inline-block;
  margin-top: -4px;
  margin-left: 4px;
  position: absolute;

  ${TooltipContainer} {
    transition: 200ms all ease-in;
    transform: translate(-30%, -110%);
    opacity: 0;
    visibility: hidden;
  }

  &:hover ${TooltipContainer} {
    transform: translate(-30%, -100%);
    opacity: 1;
    visibility: visible;
  }
  `;
